export default defineNuxtPlugin(() => {
  if (import.meta.client && window?.gtranslateSettings) {
    window.gtranslateSettings = {
      default_language: 'en',
      wrapper_selector: '.gtranslate_wrapper',
    };
  }
});
